import React from "react";
import Stand from "./Stand";
import TvStand from "./TvStand";

export default function Hobbies(props) {
  return (
    <>
      <Stand />
      <TvStand />
    </>
  );
}
